export function normalizeMemberInfo(userInfo) {
  const user = userInfo || {}
  const hasPersonalApply = user.personalApplyState !== null
    && user.personalApplyState !== undefined
    && user.personalApplyState !== ''
  const hasCompanyApply = user.companyApplyState !== null
    && user.companyApplyState !== undefined
    && user.companyApplyState !== ''

  let memberType = String(user.memberType || '').toUpperCase()
  if (!memberType && hasPersonalApply) memberType = 'PERSONAL'
  if (!memberType && hasCompanyApply) memberType = 'ENTERPRISE'

  let applyState = null
  if (memberType === 'PERSONAL' || (!hasCompanyApply && hasPersonalApply)) {
    applyState = hasPersonalApply ? Number(user.personalApplyState) : null
  } else if (hasCompanyApply) {
    applyState = Number(user.companyApplyState)
  }

  return {
    memberType,
    applyState,
    hasApplied: applyState === 0 || applyState === 1 || applyState === 2
  }
}

export function getApplyRoute(userInfo) {
  const status = normalizeMemberInfo(userInfo)
  if (status.applyState === 0) return '/apply/wait'
  if (status.applyState === 1) return '/apply/success'
  if (status.applyState === 2) return '/apply/reject'
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/memberStatus.js